export interface GridRowDef {
    // Name of the boolean field that should be considered in each row to enable/disable delete
    isDeletableField: string;
    // Name of the boolean field that should be considered in each row to enable/disable edit
	isEditableField: string;
}